import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Shared horizontal container. Centralizes max-width/gutter so every
 * section lines up, and so the same rhythm can be reused by the app later.
 */
const Container = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("container", className)} {...props} />
  ),
);
Container.displayName = "Container";

export { Container };
